import { useGetAccountsQuery } from '../../../../redux/api/fymAPI';
import { useAccountId, useUserToken } from '../../../../redux/slices/appInfo/hooks';

/** The name of the active artist ("For every song of LaziiBee"), or '' before the list loads. */
export function useActiveArtistName(): string {
  const userToken = useUserToken();
  const activeAccountId = useAccountId();
  const { name } = useGetAccountsQuery(undefined, {
    skip: !userToken,
    selectFromResult: ({ data }) => ({
      name: data?.accounts.find((account) => account.id === activeAccountId)?.name ?? '',
    }),
  });
  return name;
}
